
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LessonSectionsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LessonSection"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"format"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"duration"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"notes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isRotational"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isMain"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"workTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"restTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rounds"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lessonSectionTemplate"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"format"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"workTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"restTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rounds"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hideDescriptionField"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hideTitleField"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hideWorkRestField"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"sectionExerciseGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"DISPLAY_ORDER"}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"duration"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showTitle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"notes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sectionExercises"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SectionExerciseFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"sectionExerciseGroups"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"duration"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showTitle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"notes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sectionExercises"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SectionExerciseFragment"},"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sectionExerciseGroupTemplate"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"format"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":802}};
    doc.loc.source = {"body":"#import \"src/app/graphql/fragments/section-exercise.gql\"\n\nfragment LessonSectionsFragment on LessonSection {\n  id\n  format\n  duration\n  description\n  notes\n  name\n  isRotational\n  isMain\n  workTime\n  restTime\n  rounds\n  lessonSectionTemplate {\n    id\n    format\n    workTime\n    restTime\n    rounds\n    hideDescriptionField\n    hideTitleField\n    hideWorkRestField\n  }\n  sectionExerciseGroups(orderBy: DISPLAY_ORDER) {\n    id\n    name\n    description\n    duration\n    showTitle\n    notes\n    sectionExercises {\n      ...SectionExerciseFragment\n    }\n    sectionExerciseGroups {\n      id\n      name\n      description\n      duration\n      showTitle\n      notes\n      sectionExercises {\n        ...SectionExerciseFragment\n      }\n    }\n    sectionExerciseGroupTemplate {\n      id\n      format\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("src/app/graphql/fragments/section-exercise.gql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["LessonSectionsFragment"] = oneQuery(doc, "LessonSectionsFragment");
        
